const PowerPoint = ({ size }: { size: number }) => (
  <svg
    width={size}
    height={size}
    viewBox={`0 0 ${size} ${size}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 15.9231L19 18.0001L17 3.00006C13.5624 2.98996 10.2616 4.34579 7.82369 6.7693C5.38574 9.19281 4.01033 12.4855 4 15.9231Z"
      fill="#ED6C47"
    />
    <path
      d="M30 16C29.9929 12.5544 28.6209 9.25192 26.1845 6.81549C23.7481 4.37906 20.4456 3.00713 17 3V16L23 17L30 16Z"
      fill="#FF8F6B"
    />
    <path
      d="M30 16C30 19.4478 28.6304 22.7544 26.1924 25.1924C23.7544 27.6304 20.4478 29 17 29C13.5522 29 10.2456 27.6304 7.80761 25.1924C5.36964 22.7544 4 19.4478 4 16H30Z"
      fill="#D35230"
    />
    <path
      opacity="0.5"
      d="M17.0001 11C17.0001 10.7348 16.8948 10.4804 16.7072 10.2929C16.5197 10.1054 16.2653 10 16.0001 10H5.47412C5.05189 10.81 4.71668 11.6624 4.47412 12.543V19.457C4.93056 21.108 5.70993 22.6522 6.76712 24H15.8331C16.1424 23.9992 16.4388 23.876 16.6574 23.6573C16.8761 23.4386 16.9993 23.1423 17.0001 22.833V11Z"
      fill="#000000"
    />
    <path
      opacity="0.1"
      d="M17.0001 11C17.0001 10.7348 16.8947 10.4804 16.7072 10.2929C16.5197 10.1054 16.2653 10 16.0001 10H5.4741C4.31832 12.2102 3.8255 14.7072 4.05488 17.1908C4.28426 19.6744 5.22607 22.0389 6.7671 24H15.8331C16.1424 23.9992 16.4387 23.876 16.6574 23.6573C16.8761 23.4386 16.9993 23.1423 17.0001 22.833V11Z"
      fill="#000000"
    />
    <path
      d="M14.833 9H3.167C2.52248 9 2 9.52248 2 10.167V21.833C2 22.4775 2.52248 23 3.167 23H14.833C15.4775 23 16 22.4775 16 21.833V10.167C16 9.52248 15.4775 9 14.833 9Z"
      fill="#C43E1C"
    />
    <path
      d="M9.194 11.4C10.1036 11.3391 11.0054 11.6027 11.739 12.144C12.04 12.4125 12.2759 12.746 12.4289 13.1192C12.5818 13.4924 12.6479 13.8955 12.622 14.298C12.6317 14.9482 12.4821 15.5909 12.186 16.17C11.8865 16.6485 11.4552 17.0305 10.944 17.27C10.3596 17.541 9.72101 17.6747 9.077 17.661H7.311V20.681H5.5V11.4H9.194ZM7.311 16.046H8.87C9.36401 16.0824 9.85423 15.9365 10.248 15.636C10.4097 15.4685 10.5347 15.2692 10.615 15.0507C10.6952 14.8321 10.7289 14.5993 10.714 14.367C10.714 13.345 10.1187 12.834 8.928 12.834H7.311V16.046Z"
      fill="#FFFFFF"
    />
  </svg>
);

export default PowerPoint;
